import { render, staticRenderFns } from "./mathModal.vue?vue&type=template&id=61633111&lang=pug&"
import script from "./mathModal.vue?vue&type=script&lang=js&"
export * from "./mathModal.vue?vue&type=script&lang=js&"
import style0 from "./mathModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports